import { FC } from 'react';

interface AuthGuardProps {
  is_demo_user: boolean;
  needAuthGuard?: boolean;
  children?: React.ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({
  is_demo_user,
  needAuthGuard = true,
  children
}) => {
  if (needAuthGuard && !is_demo_user) return null;

  return <>{children}</>;
};

export default AuthGuard;
